export default "__VITE_ASSET__$JspEduQ__"